import {
  Component, OnInit,
  OnDestroy, ViewChild
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SettingsService } from '@core';
import { AuthService } from '@shared/auth/auth.service';
import { ILabsListing } from 'app/models/core/home/labs-listing';
import { Keys } from 'app/models/core/keys';
import { IDemographics } from 'app/models/core/lab/demographics';
import { SharedService } from 'app/services/core/shared.service';
import { LabService } from 'app/services/lab/lab.service';
import { Subscription } from 'rxjs';
import { HomeService } from '../../services/home/home.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  providers: [HomeService],
})

export class HomeComponent implements OnInit, OnDestroy {
  labs: ILabsListing[] = [];
  mode = 'list';

  displayedColumns: string[] = ['cliaSchedule', 'stateNumber', 'cliaNumber', 'labName'
    , 'outOfState', 'covidLab', 'labType', 'labStatus', 'siteAddress', 'siteCity', 'labDirector'
  ];
  dataSource = new MatTableDataSource<ILabsListing>(this.labs);

  expandedElement: ILabsListing | null;
  selectedLab: string = '';
  processing: boolean = true;

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  notifySubscription: Subscription;
  themeSubscription: Subscription;
  labListing: Subscription;

  labsCount = 0;
  search = "";
  searchParameter = "";
  typeParameter = "";
  certParameter = "";
  labFilter = "";
  labStatus = "Open";
  type = "None";
  cert = "None";
  options = this.settings.getOptions();
  darkMode: string;
  tempStatus = '';
  canAdd = false;

  labsFilter: "";
  mainRoles: string[] = ['Admin', 'OfficeAdmin', 'LabTech', 'ReadOnly'];
  addRoles: string[] = ['Admin', 'OfficeAdmin'];

  certList = Keys.certType;
  typeList = Keys.labType;

  newLab: IDemographics;

  newLabGroup = new UntypedFormGroup({
    LabName: new UntypedFormControl('',[Validators.maxLength(66), Validators.required]),
    StateNumber: new UntypedFormControl(''),
    CliaNumber: new UntypedFormControl('38D', [Validators.maxLength(10), Validators.required]),
    TaxId: new UntypedFormControl('', [Validators.maxLength(10), Validators.required]),
    LabType: new UntypedFormControl('', [Validators.required]),
    CertificateType: new UntypedFormControl('', [Validators.required]),
  });


  constructor(
    public homeService: HomeService,
    public sharedService: SharedService,
    public settings: SettingsService,
    private labService: LabService,
    public authService: AuthService
  ) { }

  ngOnInit() {
    this.notifySubscription = this.settings.notify.subscribe(res => {
    });
    this.search = sessionStorage.getItem('searchFilter') == null ? '' : sessionStorage.getItem('searchFilter');
    this.tempStatus = sessionStorage.getItem('labStatus');
    this.labStatus = this.tempStatus == null ? 'Open' : this.labStatus;
    this.type = sessionStorage.getItem('type') == null ? '' : sessionStorage.getItem('type');
    this.cert = sessionStorage.getItem('cert') == null ? '' : sessionStorage.getItem('cert');
    this.searchLabs();
    this.dataSource.filter = this.labFilter;
    this.mode = 'list';
    this.canAdd = this.authService.userHasAtLeastOneRole(['Admin','OfficeAdmin']);
  }

  ngOnDestroy() {
    this.notifySubscription.unsubscribe();
  }

  searchLabs() {
    // Check for valid values
    if (!(this.search === '') || this.cert != '' || this.type != '') {
      this.certParameter = this.cert === '' ? 'None' : this.cert;
      this.typeParameter = this.type === '' ? 'None' : this.type;
      this.searchParameter = this.search == '' ? 'null' : this.search;
      this.labListing = this.homeService.getLabsListing(this.labStatus, this.typeParameter,
        this.certParameter, this.searchParameter).subscribe(res => {
          this.labs = res;
          this.dataSource.data = this.labs;
          this.timeout();
       },
          error => {
            console.error('error: ' + error.statusText);
           this.labsCount = 0;
          },
          () => {
          }
        )
    }
    else {
      // Clear if search is empty
      this.labs = [];
      this.dataSource.data = this.labs;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
    this.labFilter = "";
    if (this.labStatus != 'null') {
      sessionStorage.setItem('searchFilter', this.search);
    }
    sessionStorage.setItem('searchFilter', this.search);
    sessionStorage.setItem('labStatus', this.labStatus);
    sessionStorage.setItem('type', this.type);
    sessionStorage.setItem('cert', this.cert);
  }

  authorized(roles: string[]): boolean {
    return this.authService.isAuthorized(roles);
  }
  
  addLabs() {
    this.mode = 'add';
    this.homeService.getAddLab().subscribe(res => {
        this.newLab = res;
        this.newLabGroup.controls['StateNumber'].setValue(this.newLab.stateNumber);
      },
        error => {
          console.error('error: ' + error.statusText);
        },
        () => {
        }
      )
  }

  saveNewLab() {
    if (this.newLabGroup.valid){
      let form = this.newLabGroup.value;
      this.newLab.cliaNumber = form.CliaNumber;
      this.newLab.labName = form.LabName;
      this.newLab.taxId = form.TaxId;
      this.newLab.labType = form.LabType;
      this.newLab.certificateType = form.CertificateType;

    this.homeService.saveAddLab(this.newLab).subscribe(
      () => {
        this.labService.setupDemographics(this.newLab.stateNumber);
      },
        error => {
          console.error('error: ' + error.statusText);
          this.labsCount = 0;
        },
        () => {
        }
      )
    }
  }

  cancel(){
    this.mode = 'list'
  }

  timeout() {
    setTimeout(() => {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }, 100);
  }

  filterTable(evnt: Event) {
    this.labFilter = (evnt.target as HTMLInputElement).value;
    this.dataSource.filter = this.labFilter.trim().toLowerCase();
    sessionStorage.setItem('labFilter', this.labFilter);
  }

  clearFilter() {
    this.labFilter = "";
    this.dataSource.filter = this.labFilter;
    sessionStorage.setItem('labFilter', this.labFilter)
  }

  clearCert() {
    this.cert = "";
    this.searchLabs();
  }

  clearType() {
    this.type = "";
    this.searchLabs();
  }

  clearSearch() {
    this.search = "";
    this.searchLabs();
  }

  rowclick(row: ILabsListing) {
    this.labService.setupDemographics(row.stateNumber);
  }

  getPageSizeOptions(): number[] {
    if (this.dataSource.data.length > 20) {
      return [10, 20, this.dataSource.data.length];
    } else {
      return [10, 20];
    }
  }

}
